module.exports = __webpack_public_path__ + "static/media/Sahil Arya.29520648.jpeg";